export const STORE_SESSIONS = 'SessionsUI';
export type STORE_SESSIONS = typeof STORE_SESSIONS;
